module.exports = __webpack_public_path__ + "img/no-articles.65b6ead2.svg";